import React from 'react';
import { useParams } from 'react-router-dom';
import Privileges from '../privileges/Privileges';

export default function CollectionsDetails() {
  const { orgId } = useParams();
  return <Privileges organizationId={orgId} />
}